import { useCallback, useContext } from "react";
import { ReactReduxContext } from "react-redux";
import { captureAppException, buildLogContext } from "../Utils/appLogger";

/**
 * Log an error to the console with Redux user context.
 * Uses {@link ReactReduxContext} so it works without a Provider (tests) and reads
 * from the correct store instance when wrapped in {@link Provider}.
 */
export function useReportError() {
  const reduxContext = useContext(ReactReduxContext);
  const store = reduxContext?.store;

  return useCallback(
    (
      message: string,
      error: unknown,
      extras?: Record<string, string | number | boolean>
    ) => {
      const userDetails = store?.getState().user?.userDetails;
      console.error(message, error);
      captureAppException(
        message,
        error,
        buildLogContext(
          "app",
          "unhandled-error",
          userDetails?.id,
          userDetails?.companyId,
          userDetails?.storeId,
          extras
        )
      );
    },
    [store]
  );
}
